import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
          准备好开始下载了吗？
        </h2>
        <p className="text-foreground-500 text-base mb-8 max-w-lg mx-auto">
          加入问鼎下载，与3800万用户一起享受安全、快速的正版下载体验。海量资源，一键获取。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/software"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-semibold text-base transition-all duration-200 whitespace-nowrap"
          >
            立即探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50 hover:bg-background-200 text-foreground-700 font-medium text-base border border-background-200/70 transition-all duration-200 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}